export enum StoreModeEnum {
  Demo = 'DEMO',
  Production = 'PRODUCTIVO',
}